export const MethodRequests = {
    POST: "POST",
    DELETE: "DELETE",
    PUT: "PUT"
} as const;

export const IPIFY_API_URL = "https://api.ipify.org?format=json";
